// Lot Search

<template>
  <section class="lms5000-container">
    <div class="lms5000 white border-main shadow-dark">
      <Ul class="crumbs text-charcoal mb-2">
        <li><sym-link to="/">Home</sym-link></li>
        <li><sym-link :to="getPortalPagePath()">Portal</sym-link></li>
        <li><span aria-current="page">Lot Search</span></li>
      </Ul>

      <div class="page-title lams curved mb-2">
        <h5 class="serif mb-0">
          <i class="fa fa-search fa-lg ml-1 mr-2"></i>Lot Search
        </h5>
      </div>

      <div
        class="controls lams-light curved-bottom mb-3 shadow-light border-main"
      >
        <sym-combo
          plain
          vertical
          align="bottom"
          v-model="regionId"
          caption="Region"
          display-field="regionFullName"
          :datasource="regions"
          @changing="onRegionIdChanging"
          @changed="onRegionIdChanged()"
        ></sym-combo>
        <sym-combo
          plain
          vertical
          align="bottom"
          v-model="provinceId"
          caption="Province"
          display-field="provinceName"
          :datasource="provinces"
          @changed="onProvinceIdChanged()"
        ></sym-combo>
        <sym-combo
          plain
          vertical
          align="bottom"
          v-model="municipalityId"
          caption="Municipality"
          display-field="municipalityName"
          :datasource="municipalities"
          @changed="onMunicipalityIdChanged()"
        ></sym-combo>
        <!-- <sym-combo
          plain
          vertical
          align="bottom"
          v-model="barangayId"
          caption="Barangay"
          display-field="barangayName"
          :datasource="barangays"
        ></sym-combo> -->
        <sym-text
          plain
          vertical
          align="bottom"
          v-model="lotNumber"
          caption="Lot Number"
        ></sym-text>
        <sym-text
          plain
          vertical
          align="bottom"
          v-model="surveyPlan"
          caption="Survey Plan"
        ></sym-text>
      </div>

      <div class="d-flex">
        <button
          type="button"
          class="text-center info lg-2 w-100 mr-2"
          :disabled="!canSearch"
          @click="onSearch"
        >
          <i class="fa fa-search fa-lg mr-2"></i><br />
          <p class="mb-0">Search</p>
        </button>
        <button
          type="button"
          class="text-center warning lg-2 w-100"
          @click="searchAgain"
        >
          <i class="fa fa-undo mr-2"></i>Reset
        </button>
      </div>

      <div
        class="d-flex justify-center align-items-center danger-light p-2 mt-4 curved"
        v-if="parcels && parcels.length === 0"
      >
        <span class="lg-2"
          ><i class="fa fa-info-circle fa-lg mr-2"></i>No records found.</span
        >
        <button
          type="button"
          class="info shadow-dark ml-3 lg-2"
          @click="searchAgain"
        >
          <i class="fa fa-undo mr-2"></i>Search Again
        </button>
      </div>

      <div
        class="lg-3 d-flex justify-center align-items-center p-2 curved"
        v-if="parcels && parcels.length !== 0"
      >
        <span class="lg-3"
          ><b>{{ parcelCount }} record/s found.</b></span
        >
      </div>

      <sym-pager
        v-model="currentPage"
        :totalPages="totalPages"
        align="center"
        @change="onPageChange"
        @pager:rangeChanged="rangeStart = $event"
        v-if="currentPage && parcels && parcels.length > 0"
        class="lams-light border-main curved mb-3 pt-2 px-2"
      >
      </sym-pager>

      <div class="table-scroll-wrapper" v-show="parcels && parcels.length">
        <table class="table-scroll">
          <thead class="info-light">
            <tr class="text-charcoal">
              <th class="w-25">Survey Plan</th>
              <th class="w-20">Lot Number</th>
              <th class="w-40">Location</th>
              <th class="w-15 text-right">Area</th>
            </tr>
          </thead>

          <tbody class="white text-charcoal">
            <tr
              v-for="p in parcels"
              :key="p.parcelId"
              @click="onParcelClick(p)"
            >
              <td class="w-25">{{ p.surveyPlan }}</td>
              <td class="w-20">{{ p.lotNumber }}</td>
              <td class="w-40">{{ p.locationName }}</td>
              <td class="w-15 text-right">
                {{ core.toDecimalFormat(p.area) }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <sym-pager
        v-model="currentPage"
        :totalPages="totalPages"
        align="center"
        @change="onPageChange"
        @pager:rangeChanged="rangeStart = $event"
        v-if="currentPage && parcels && parcels.length > 0"
        class="lams-light border-main curved mt-3 pt-2 px-2"
      >
      </sym-pager>

      <button
        type="button"
        class="primary text-center w-100 lg-1 shadow mt-3 mb-2"
        @click="goBack()"
      >
        <i class="fa fa-arrow-left mr-2"></i> Back
      </button>
    </div>
  </section>
</template>

<script>
import { get, encode } from "../../js/http";

import * as lams from "../../js/lams";

import PageBase from "../PageBase.vue";

export default {
  extends: PageBase,
  name: "lms5000",

  data() {
    return {
      regionId: 0,
      regions: [],
      provinceId: 0,
      provinces: [],
      municipalityId: 0,
      municipalities: [],
      barangayId: 0,
      barangays: [],
      lotNumber: "",
      // claimant: '',
      surveyPlan: "",
      parcels: null,
      cartItems: [],
      cartKey: "",

      parcelCount: -1,
      currentPage: 1,
      totalPages: 0,
    };
  },

  computed: {
    canSearch() {
      const me = this;

      if (me.regions.length === 0) {
        return false;
      }

      if (me.provinces.length === 0) {
        return false;
      }

      if (me.municipalities.length === 0) {
        return false;
      }

      return me.regionId && me.provinceId && me.municipalityId;
    },

    hasItem() {
      if (this.cartItems.length > 0) {
        return true;
      }
    },
  },

  methods: {
    getTargetPath() {
      const me = this,
        q = {};

      if (me.regionId) {
        q.regionId = me.regionId;
      }

      if (me.provinceId) {
        q.provinceId = me.provinceId;
      }

      if (me.municipalityId) {
        q.municipalityId = me.municipalityId;
      }

      if (me.barangayId) {
        q.barangayId = me.barangayId;
      }

      // if (me.claimant) {
      //   q.claimant = me.claimant;
      // }

      if (me.surveyPlan) {
        q.surveyPlan = me.surveyPlan;
      }

      if (me.lotNumber) {
        q.lotNumber = me.lotNumber;
      }

      q.page = me.currentPage;

      return {
        name: me.$options.name,
        query: q,
      };
    },

    syncValues(p, q) {
      const me = this;

      if ("regionId" in q && me.core.isInteger(q.regionId)) {
        me.regionId = parseInt(q.regionId);
      } else {
        me.regionId = 0;
      }

      if ("provinceId" in q && me.core.isInteger(q.provinceId)) {
        me.provinceId = parseInt(q.provinceId);
      } else {
        me.provinceId = 0;
      }

      if ("municipalityId" in q && me.core.isInteger(q.municipalityId)) {
        me.municipalityId = parseInt(q.municipalityId);
      } else {
        me.municipalityId = 0;
      }

      if ("barangayId" in q && me.core.isInteger(q.barangayId)) {
        me.barangayId = parseInt(q.barangayId);
      } else {
        me.barangayId = 0;
      }

      // if ('claimant' in q) {
      //   me.claimant = q.claimant;
      // } else {
      //   me.claimant = '';
      // }

      if ("surveyPlan" in q) {
        me.surveyPlan = q.surveyPlan;
      } else {
        me.surveyPlan = "";
      }

      if ("lotNumber" in q) {
        me.lotNumber = q.lotNumber;
      } else {
        me.lotNumber = "";
      }

      if ("page" in q && me.core.isInteger(q.page)) {
        me.currentPage = parseInt(q.page);
      }
    },

    loadData() {
      const me = this;

      if (!me.regionId) {
        return;
      }

      let wait = me.wait();

      me.getParcelCount()
        .then((count) => {
          if (!count) {
            return [];
          }
          me.parcelCount = count;
          me.totalPages = Math.ceil(me.parcelCount / me.itemsPerPage);
          return me.getParcels();
        })
        .then((parcels) => {
          me.stopWait(wait);
          me.parcels = parcels;
          me.replaceUrl();
        })
        .catch((fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        });
    },

    onSearch() {
      const me = this;

      me.currentPage = 1;
      me.loadData();
      // // eslint-disable-next-line no-console
      // console.log(me.loadData);
    },

    onPageChange(page) {
      const me = this;

      me.currentPage = page;
      me.reload();
    },

    onRegionIdChanging(e) {
      const me = this;

      let regionInfo = me.regions.find(
        (obj) => obj.regionId === e.proposedValue
      );
      e.message = `Region '${regionInfo.regionFullName}' is offline.`;

      if (!regionInfo.apiHostAddress && regionInfo.regionId) {
        e.preventDefault();
        return;
      }

      if (e.proposedValue) {
        e.callback = me.regionIdCallback;
      }
    },

    regionIdCallback(e) {
      const me = this,
        wait = me.wait();

      return me.getLinkStatus(e.proposedValue).then(
        (statusCode) => {
          me.stopWait(wait);

          let isOnline = statusCode === 200;
          return isOnline;
        },
        () => {
          me.stopWait(wait);
          return false;
        }
      );
    },

    onRegionIdChanged() {
      const me = this,
        wait = me.wait();

      me.provinces = [];
      me.municipalities = [];
      me.barangays = [];

      me.getProvinces().then(
        (data) => {
          me.stopWait(wait);
          me.provinces = data;

          if (me.provinces.length) {
            me.provinces.unshift({
              provinceId: 0,
              provinceName: "--- Select Province ---",
            });
            me.setFocus("provinceId");
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    onProvinceIdChanged() {
      const me = this,
        wait = me.wait();

      me.municipalities = [];
      me.barangays = [];

      me.getMunicipalities().then(
        (data) => {
          me.stopWait(wait);
          me.municipalities = data;

          if (me.municipalities.length) {
            me.municipalities.unshift({
              municipalityId: 0,
              municipalityName: "--- Select Municipality ---",
            });
            me.setFocus("municipalityId");
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    onMunicipalityIdChanged() {
      const me = this,
        wait = me.wait();

      me.getBarangays().then(
        (data) => {
          me.stopWait(wait);
          me.barangays = data;

          if (me.barangays.length) {
            me.barangays.unshift({
              barangayId: 0,
              barangayName: "--- Select Barangay ---",
            });
            me.setFocus("barangayId");
          }
        },
        (fault) => {
          me.stopWait(wait);
          me.showFault(fault);
        }
      );
    },

    getLocalStorage() {
      const me = this;

      let info = me.getLocalItem(me.cartKey);

      if (info) {
        me.cartItems = info;
      }
    },

    getParcelCount() {
      const me = this;

      let q = this.getSearchQuery();

      if (q) {
        return get("api/rgn/" + me.regionId + "/lot-search/count?" + q);
      } else {
        return get("api/rgn/" + me.regionId + "/lot-search/count");
      }
    },

    getParcels() {
      const me = this;

      let q = "ipp=" + (me.itemsPerPage || 10);
      q = q + "&page=" + (me.query.page || 1);

      let sq = me.getSearchQuery();
      if (sq) {
        return get(
          "api/rgn/" +
            me.regionId +
            "/lot-search?" +
            me.getSearchQuery() +
            "&" +
            q
        );
      } else {
        return get("api/rgn/" + me.regionId + "/lot-search?" + q);
      }
    },

    getSearchQuery() {
      const me = this;
      let q = "";

      if (me.regionId) {
        if (q) {
          q += "&";
        }
        q += "regionId=" + me.regionId;
      }

      if (me.provinceId) {
        if (q) {
          q += "&";
        }
        q += "provinceId=" + me.provinceId;
      }

      if (me.municipalityId) {
        if (q) {
          q += "&";
        }
        q += "municipalityId=" + me.municipalityId;
      }

      if (me.barangayId) {
        if (q) {
          q += "&";
        }
        q += "barangayId=" + me.barangayId;
      }

      // if (me.claimant) {
      //   if (q) { q += '&'; }
      //   q = 'claimant=' + encode(me.claimant);
      // }

      if (me.surveyPlan) {
        if (q) {
          q += "&";
        }
        q = "surveyPlan=" + encode(me.surveyPlan);
      }

      if (me.lotNumber) {
        if (q) {
          q += "&";
        }
        q += "lotNumber=" + encode(me.lotNumber);
      }

      return q;
    },

    onParcelClick(parcel) {
      const me = this;

      let route = {
        name: "lms5010",
        query: {
          regionId: me.regionId,
          parcelId: parcel.parcelId,
        },
      };
      me.go(route);
    },

    //API CALLS

    getProvinces() {
      return get("api/provinces?regionId=" + this.regionId);
    },

    getMunicipalities() {
      const me = this;
      let q = "";

      if (me.regionId) {
        if (q) {
          q += "&";
        }
        q += "regionId=" + me.regionId;
      }

      if (me.provinceId) {
        if (q) {
          q += "&";
        }
        q += "provinceId=" + me.provinceId;
      }

      return get("api/municipalities?" + q);
    },

    getBarangays() {
      const me = this;
      let q = "";

      if (me.regionId) {
        if (q) {
          q += "&";
        }
        q += "regionId=" + me.regionId;
      }

      if (me.municipalityId) {
        if (q) {
          q += "&";
        }
        q += "municipalityId=" + me.municipalityId;
      }

      return get("api/barangays?" + q);
    },

    getLinkStatus(regionId) {
      return get("api/regions/" + regionId + "/link-status");
    },

    searchAgain() {
      const me = this;

      me.parcels = null;
      me.provinceId = 0;
      me.municipalityId = 0;
      me.barangayId = 0;
      me.lotNumber = "";
      // me.claimant = '';
      me.surveyPlan = "";
      (me.provinces = []),
        (me.municipalities = []),
        (me.barangays = []),
        (me.regionId = 0);

      me.setFocus("regionId");
    },

    getPortalPagePath() {
      let page = "",
        typeId = this.accountTypeId;

      if (typeId === 1) {
        page = "lms1010";
      }
      if (typeId === 2) {
        page = "lms1020";
      }
      if (typeId === 3) {
        page = "lms1030";
      }
      if (typeId === 4) {
        page = "lms1040";
      }
      if (page) {
        return this.sym.getPath(page);
      }
      return "/";
    },
  },

  created() {
    this.itemsPerPage = 10;
    this.accountTypeId = 0;
  },

  mounted() {
    const me = this;

    me.accountTypeId = me.sym.userInfo.accountTypeId;

    me.parcels = null;
    me.currentPage = 1;

    me.setFocus("regionId");
    me.regions = lams.getRegionList().filter((o) => o.apiHostAddress);
    me.regions.unshift({
      regionId: 0,
      regionFullName: "--- Select Region ---",
    });

    me.syncValues(me.params, me.query);
    me.cartKey = me.sym.userInfo.accountCode + "*" + me.regionId + "*CART";
    me.getLocalStorage();

    if (me.regionId !== 0) {
      me.loadData();
      me.onRegionIdChanged();
      me.onProvinceIdChanged();
      me.onMunicipalityIdChanged();
    }

    me.$nextTick(() => {
      setTimeout(() => {
        me.setFocus("regionId");
      }, 200);
    });
  },

  beforeRouteUpdate(to, from, next) {
    this.syncValues(to.params, to.query);
    next();

    if (Object.keys(from.query).length) {
      this.loadData();
    }
  },
};
</script>

<style scoped>
.lms5000-container {
  display: flex;
  justify-content: center;
  padding-top: 1.5rem;
  padding-bottom: 3rem;
}

.lms5000 {
  width: 80%;
  padding: 2rem;
  border-radius: 0.375rem;
}

.page-title {
  padding: 0.875rem;
}

.controls {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  row-gap: 0.5rem;
  column-gap: 1rem;
  padding: 1rem;
  padding-bottom: 1.5rem;
}

.controls >>> .form-control {
  margin-bottom: 2px;
}

.controls >>> .input-tag {
  padding-bottom: 2px;
  margin-left: 2px;
}

.table-scroll-wrapper {
  overflow-x: auto;
}

.table-scroll {
  /* display: block; */
  /* overflow-x: auto; */
  white-space: nowrap;
  width: -moz-available;
  width: -webkit-fill-available;
}

.table-scroll tbody tr:hover {
  background-color: ivory;
  box-shadow: 2px 2px 16px 8px rgba(48, 48, 48, 0.3);
  cursor: pointer;
  transition: all 0.3s ease-in-out;
}

td,
th {
  vertical-align: top;
}

@media (max-width: 1024px) {
  .lms5000 {
    width: 90%;
    padding: 2rem;
  }
  .controls {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 700px) {
  .controls {
    grid-template-columns: repeat(1, 1fr);
    gap: 0.25rem;
  }
}

@media (max-width: 640px) {
  .lms5000-container {
    padding-top: 0;
    padding-bottom: 0;
  }

  .lms5000 {
    width: 100%;
    padding: 1rem;
    border-radius: 0;
  }
}

@media (max-width: 420px) {
  .lms5000 {
    padding: 0.5rem;
  }
}
</style>
